import React from 'react';
import styles from './payroll.module.scss';
import { KoAffix, KoTabs, KoTitle } from 'packages';
import { Outlet } from 'react-router';
import { Link } from 'react-router-dom';

export default function PayRolls() {
  const TABS = [
    {
      key: 'dashboard',
      label: <Link to="/paybooks/payroll/dashboard">Dashboard</Link>,
      children:''
    },
    {
      key: 'attendance',
      label: <Link to="/paybooks/payroll/attendance">Attendance</Link>,
      children:''
    },
    {
      key: 'payruns',
      label: <Link to="/paybooks/payroll/payruns">Pay Runs</Link>,
      children:''
    },
    {
      key: 'payroll-history',
      label: <Link to="/paybooks/payroll/payroll-history">Payroll History</Link>,
      children:''
    },
    {
      key: 'form-16',
      label: <Link to="/paybooks/payroll/form16">Form 16</Link>,
      children:''
    },
    {
      key: 'loans',
      label: <Link to="/paybooks/payroll/loans">Loans</Link>,
      children:''
    },
    {
      key: 'proof-of-investments',
      label: <Link to="/paybooks/payroll/proof-of-investments">Proof of Investments</Link>,
      children:''
    },
    {
      key: 'reimbursements',
      label: <Link to="/paybooks/payroll/reimbursements">Reimbursements</Link>,
      children:''
    },
    {
      key: 'salary-revision',
      label: <Link to="/paybooks/payroll/salary-revision">Salary Revision</Link>,
      children:''
    }
  ];

  return (
    <div className={`${styles.wrapper} profileSection`}>
      <KoAffix top={50}>
        <div className={styles.header}>
          <KoTitle text="Payroll" level={4} />
          <KoTabs options={TABS}  />
        </div>
      </KoAffix>
      <Outlet />
    </div>
  );
}
